// src/MainApp.jsx

import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Homepage from './pages/Homepage';

import RegisterSchool from './pages/RegisterSchool';

import ContactForm from './pages/Contact/contactForm';
import Navbar from './components/Navbar';



const MainApp = () => {
 

  return (
    <div className="bg-gradient-to-r from-gray-900 to-gray-200 w-screen h-screen overflow-x-hidden">
       <Navbar />

      <Routes>
        <Route path="/" element={<Homepage />} />
        {/* <Route path="/loginPage" element={<LoginPage />} /> */}
        <Route path="/contactForm" element={<ContactForm />} />
        <Route path="/registerSchool" element={<RegisterSchool />} />
        {/* <Route path="/Admin/dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
        <Route path="/Adminstrator/dashboard" element={<Dashboard />} />
        <Route path="/StudentDashboard" element={<PrivateRoute><StudentDashboard /></PrivateRoute>} />
        <Route path="/FacultyDashboard" element={<PrivateRoute><FacDashboard /></PrivateRoute>} />
        <Route path="/StaffDashboard" element={<PrivateRoute><StaffDashboard /></PrivateRoute>} /> */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
};

export default MainApp;
